import { render, staticRenderFns } from "./QbbAssistant.vue?vue&type=template&id=694d2591&scoped=true&"
import script from "./QbbAssistant.vue?vue&type=script&lang=js&"
export * from "./QbbAssistant.vue?vue&type=script&lang=js&"
import style0 from "./QbbAssistant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QbbAssistant.vue?vue&type=style&index=1&id=694d2591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d2591",
  null
  
)

export default component.exports